

import React from "react";
import { CheckCircle } from "lucide-react";

// WhatsApp Leads Data
const whatsappLeadsData = [
  {
    heading: "Capture More Leads with WhatsApp Ads",
    points: [
      "Run click-to-WhatsApp ads to grab customer interest fast.",
      "Add a WhatsApp widget to websites for instant chats.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/marketing_agency/marketing_agency_2.png",
  },
  {
    heading: "Nurture Client Leads Like a Pro",
    points: [
      "Use click-to-WhatsApp ads to collect key customer details.",
      "Pop a WhatsApp widget on sites to kick off conversations.",
      "Add QR codes to ads and packaging for easy opt-ins.",
      "Share WhatsApp links on social media to connect directly.",
    ],
    // buttonText: "Get Start ",
    buttonText: "Meta Policy for Markeing Agency",
    buttonLink:"https://transparency.meta.com/policies/ad-standards/",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/marketing_agency/marketing_agency_3.png",
  },
  {
    heading: "Drive Client Sales with WhatsApp Broadcasts",
    points: [
      "Send click-to-WhatsApp ads to spark interest and intent.",
      "Use a WhatsApp widget to turn site visits into sales chats.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/marketing_agency/marketing_agency_4.png",
  },
  {
    heading: "Personalize Experiences for Client Success",
    points: [
      "Run click-to-WhatsApp ads to understand customer needs.",
      "Add a WhatsApp widget for real, one-on-one engagement.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/marketing_agency/marketing_agency_5.png",
  },
  {
    heading: "Track Campaigns with a Simple Dashboard",
    points: [
      "Use click-to-WhatsApp ads to measure engagement easily.",
      "Monitor chats and results with a WhatsApp widget on sites.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/marketing_agency/marketing_agency_6.png",
  },
  {
    heading: "Grow Your Agency with ChatMitra Partnership",
    points: [
      "Earn steady commissions for every client you bring in.",
      "Get clear, step-by-step guides to hit the ground running.",
      "Enjoy tailored demos and onboarding for your team.",
      "Count on fast, friendly support whenever you need it.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/marketing_agency/marketing_agency_7.png",
  },
];

const Marketingcycle = () => {
  return (
    <>
      <div className="bg-gradient-to-r from-pink-200 to-pink-300 py-12 px-4 text-center">
        <h1 className="text-4xl font-bold text-gray-800">Create Winning Flows for Your Clients</h1>
        <div className="my-4 flex justify-center">
          <span className="w-16 h-1 bg-gray-500 rounded-full"></span>
        </div>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">With a <span className="font-bold">98% open rate</span> and <span className="font-bold">47% click-through rate</span>, WhatsApp gives your agency the edge to deliver real, human connections that make clients stand out.</p>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
              <a
              href={item.buttonLink}
              className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
            >
              {item.buttonText}
            </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Marketingcycle;